import Field from '@/components/common/Field/Field';
import * as S from './style';
import InputText from '@/components/common/Input/InputText/InputText';
import { useState } from 'react';
import LineIcon from '@/components/Icon/lineIcon';
import { useNavigate } from 'react-router-dom';
import { useLoginApi } from '@/api/auth';
import { useModalStore } from '@/store/modalStore';
const Auth = () => {
	const { showModal } = useModalStore();
	const navigate = useNavigate();
	const [id, setId] = useState('');
	const [password, setPassword] = useState('');

	const { mutateAsync: login } = useLoginApi();
	const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPassword(e.target.value);
	};
	const handleId = (e: React.ChangeEvent<HTMLInputElement>) => {
		setId(e.target.value);
	};
	const handleLogin = async () => {
		const res = await login({
			member_id: id,
			member_password: password,
		});
		if (res.data.success) {
			navigate('/');
		} else {
			if (res.data.error.code === '86') {
				showModal('잠시 후 시도해 주세요.');
			} else {
				showModal('아이디 또는 비밀번호를 확인해 주세요.');
			}
		}
	};
	return (
		<main>
			<S.Container>
				<div className="title">로그인</div>
				<S.FieldBox>
					<Field title="아이디" error="">
						<InputText placeholder="아이디 입력" input={handleId} value={id} />
					</Field>
					<Field title="비밀번호" error="">
						<InputText type="password" placeholder="비밀번호 입력" input={handlePassword} value={password} />
					</Field>
					<S.Button type="button" onClick={handleLogin} disabled={!id || !password}>
						로그인
					</S.Button>
					<S.MenuBox>
						<S.MenuButton type="button" onClick={() => navigate('/auth/findid')}>
							아이디 찾기
						</S.MenuButton>
						<LineIcon width="2" height="12" iconColor="#DEE2E6" />
						<S.MenuButton type="button" onClick={() => navigate('/auth/findpw')}>
							비밀번호 찾기
						</S.MenuButton>
						<LineIcon width="2" height="12" iconColor="#DEE2E6" />
						<S.MenuButton type="button" onClick={() => navigate('/auth/signup')}>
							회원가입
						</S.MenuButton>
					</S.MenuBox>
				</S.FieldBox>
			</S.Container>
		</main>
	);
};
export default Auth;
